import { createFileRoute, redirect } from '@tanstack/react-router'

/** Settings has no landing page of its own yet; members is the first thing anyone opens it for. */
export const Route = createFileRoute('/_app/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/members', replace: true })
  },
})
